<template>
  <!-- Desktop Menu -->
  <nav class="bg-white shadow">
    <div class="mx-auto px-2 sm:px-6 lg:px-8">
      <div class="relative flex items-center justify-between h-16">
        <div v-on:click="toggleSideMenu">
          <burger-button></burger-button>
        </div>
        <div
          class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start"
        >
          <div class="flex-shrink-0 flex items-center">
            <img
              class="md:h-8 h-6 w-auto cursor-pointer"
              v-on:click="navigateToUsers"
              src="./../../assets/logo.png"
              alt="Zid Khabeer"
            />
          </div>
        </div>

        <!-- Profile icon on the right side -->
        <profile-menu></profile-menu>
      </div>
    </div>
  </nav>
</template>

<script>
import BurgerButton from "../Buttons/BurgerButton.vue";
import ProfileMenu from "./Navbar/ProfileMenu/ProfileMenu.vue";
import { StorageKeys } from "./../../enums/storageKeys.enum";
import router from "@/router";
import { Routes } from "./../../enums/routes.enum";

export default {
  // ======================
  // DATA
  // ======================
  data() {
    return {
      links: [],
      showMobileMenu: false,
      showProfileMenu: false,
    };
  },
  // ======================
  // Components
  // ======================
  components: {
    BurgerButton,
    ProfileMenu,
  },
  // ======================
  // Methods
  // ======================
  methods: {
    navigateToUsers() {
      //reset the sidebar style
      document.getElementById("side").style.width = "auto";
      router.push({
        name: Routes.users,
      });
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
    toggleSideMenu() {
      document.getElementById("side").classList.toggle("shown");
    },
    logout() {
      window.localStorage.removeItem(StorageKeys.token);
    },
  },
};
</script>
